import { render, staticRenderFns } from "./ComplaintsExtendReport.vue?vue&type=template&id=355c34c1&"
import script from "./ComplaintsExtendReport.vue?vue&type=script&lang=ts&"
export * from "./ComplaintsExtendReport.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports